import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'prompt', 'Prompt', [["path",{"d":"M5 7l5 5l-5 5","key":"svg-0"}],["path",{"d":"M13 17l6 0","key":"svg-1"}]]);